__turbopack_context__.v({
  "contentContainer": "EndBannerSection-module__OBrVmW__contentContainer",
  "ctaWrapper": "EndBannerSection-module__OBrVmW__ctaWrapper",
  "description": "EndBannerSection-module__OBrVmW__description",
  "heading": "EndBannerSection-module__OBrVmW__heading",
  "imageWrapper": "EndBannerSection-module__OBrVmW__imageWrapper",
  "productImage": "EndBannerSection-module__OBrVmW__productImage",
  "section": "EndBannerSection-module__OBrVmW__section",
});
